// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { AbstractProjectModel } from "@app/catalog-common";
import { ProjectDto, ProgramModel, SpaDto } from "@app/catalog";


export class ProjectModel extends AbstractProjectModel implements IBreadcrumbItemModel
{

    public thumbnailUrl: WritableSignal<string | null>;
    public program: WritableSignal<ProgramModel | null>;
    public programId: WritableSignal<string | null>;
    public canEdit: WritableSignal<boolean>;
    public shouldAddBreadcrumb: WritableSignal<boolean>;
    public projectCap: WritableSignal<string | null>;
    public spa: WritableSignal<SpaDto | null>;


    constructor()
    {
        super();
        this.thumbnailUrl = signal<string | null>(null);
        this.program = signal<ProgramModel | null>(null);
        this.programId = signal<string | null>(null);
        this.canEdit = signal<boolean>(false);
        this.shouldAddBreadcrumb = signal<boolean>(true);
        this.projectCap = signal<string | null>(null);
        this.spa = signal<SpaDto | null>(null);
    }

    public setShouldAddBreadcrumb(value: boolean): void {
        this.shouldAddBreadcrumb.set(value);
    }

    public static fromDto(dto: ProjectDto, isChecked: boolean = false)
    {
        let project = new ProjectModel();

        project.id = dto.id;
        project.name.set(dto.name);
        project.description.set(dto.description);
        project.thumbnailUrl.set(dto.thumbnailUrl);
        project.programId.set(dto.program?.id ?? null);
        project.isChecked.set(isChecked);
        project.isActive.set(dto.isActive);
        project.canEdit.set(dto.canEdit);
        project.projectCap.set(dto.cap);
        project.spa.set(dto.spa);
        return project;
    }
    
    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProjectModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProjectModel>(this.name, this.id, this, selected);    

}
